import { useMutation } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface TemplatePreview {
  subject_rendered?: string;
  body_rendered: string;
  missing_variables: string[];
}

export function useTemplatePreview(templateId: number | null) {
  const headers = useAuthHeaders(true);
  return useMutation({
    mutationFn: async (sample_data: Record<string, string | number>) => {
      const res = await fetch(`/api/cockpit/templates/${templateId}/preview`, {
        method: "POST",
        headers: {
          ...headers,
        },
        body: JSON.stringify({ sample_data }),
      });
      if (!res.ok) throw new Error("Template preview failed");
      return res.json() as Promise<TemplatePreview>;
    },
  });
}
